import { AuthenticatedLayout } from "../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { InvoiceDetail } from "../../components/InvoiceDetail";

export interface IInvoiceDetailPage {}

export const InvoiceDetailPage: FC<IInvoiceDetailPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Invoice Detail"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<InvoiceDetail />}
    />
  );
};
